import Grid from '@material-ui/core/Grid'
import React from 'react'
import { Filter, SelectInput, ReferenceInput, Datagrid, EditButton, List, Responsive, SimpleList, TextField, ReferenceField } from 'react-admin'

import { ListActions, TableRowList } from '../../../components'
import { getResource } from '../../../config/resources'

const ListFilter = (props) => {
  return (
    <Filter {...props}>
      <Grid container alwaysOn>
        <Grid item xs={12} md={4} lg={2}>
          <ReferenceInput label="Categoria" source="category" reference={getResource('layouts', 'beyond-stats')} perPage={50} allowEmpty alwaysOn>
            <SelectInput />
          </ReferenceInput>
        </Grid>
      </Grid>
    </Filter>
  )
}

const Actions = (props) => {
  return <ListActions {...props} filters={<ListFilter />} />
}

export const BeyonStatsBlocksList = (props) => {
  return (
    <List bulkActions={false} actions={<Actions />} {...props}>
      <Responsive
        small={<SimpleList primaryText={(record) => <TextField source="title" label="Title" />} secondaryText={(record) => record.title} />}
        medium={
          <Datagrid>
            <TextField source="title" label="Title" />
            <TableRowList>
              <EditButton />
            </TableRowList>
          </Datagrid>
        }
      />
    </List>
  )
}

export default BeyonStatsBlocksList
